import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NumberGraphComponent } from "./number-graph.component";
import { NotificationModule } from "libraries/component/notification/notification.module";
import { PriceModule } from "libraries/component/price/price.module";
import { LoaderModule } from "libraries/component/loader/loader.module";

@NgModule({
    imports: [
        CommonModule,
        NotificationModule,
        PriceModule,
        LoaderModule,
    ],
    declarations: [
        NumberGraphComponent,
    ],
    exports: [
        NumberGraphComponent
    ],
    providers: []
})
export class NumberGraphModule {

}
